import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { NavLink } from "react-router-dom";
import "../style/faq.css";

const faqs = [
  {
    question: "What size skip bin do I need?",
    answer:
      "It depends on the size of your project. A 2m³ bin suits small cleanups like garden waste, while 6m³-10m³ bins are better for renovations, construction debris, or large household decluttering. Contact us if you're unsure, we're happy to help you choose.",
  },
  {
    question: "How quickly can I get a bin delivered?",
    answer:
      "We offer same-day delivery in most areas when booked before midday. For other locations, next-day delivery is standard. Delivery times will be confirmed when you book online or by phone.",
  },
  {
    question: "What can and can't go in the skip bin?",
    answer:
      "General waste, household junk, garden green waste, and construction debris are all accepted. Hazardous materials such as asbestos, chemicals, paints, batteries, and tyres are not permitted.",
  },
  {
    question: "How long can I keep the bin for?",
    answer:
      "Standard hire includes a 7-day rental period. If you need it longer, you can book it for 2 or 3 weeks at an additional extra cost.",
  },
  {
    question: "Are there any hidden fees?",
    answer:
      "No. Our pricing is upfront and includes delivery, waste-type, and extension costs if applicable.",
  },
  {
    question: "Do I need a permit to place a bin on the street?",
    answer:
      "If the bin will be placed on a public road or footpath, you may need a council permit. We can guide you through the process, or you can place the bin on your driveway or property to avoid this requirement.",
  },
];

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="faq-section">
      <div className="faq-header">
        <h2>Frequently Asked Questions</h2>
        <p className="faq-subtitle">Find answers to commonly asked questions.</p>
      </div>

      <div className="faq-list">
        {faqs.map((faq, index) => (
          <div
            className={`faq-item ${activeIndex === index ? "open" : ""}`}
            key={index}
          >
            <button className="faq-question" onClick={() => toggleFAQ(index)}>
              <span>{faq.question}</span>
              <div className="faq-icon-wrap">
                {activeIndex === index ? (
                  <Minus className="faq-icon" />
                ) : (
                  <Plus className="faq-icon" />
                )}
              </div>
            </button>
            <div className="faq-answer">
              <p>{faq.answer}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="faq-contact-banner">
        <div className="faq-contact-text">
          <h3>Still have questions?</h3>
          <p>We're happy to help.</p>
        </div>
        <NavLink to="/contact" className="faq-contact-btn">
          CONTACT US
        </NavLink>
      </div>
    </section>
  );
};

export default FAQ;